// @flow
import DurationInput from './DurationInput';

export default DurationInput;